import { Reveal } from '@/components/Reveal';
import SectionIndex, { IndexEntry } from '@/components/SectionIndex';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';

/*
 * Exported so About/Index can list these alongside the About entries without
 * rendering this whole page component inside itself — which is what it used to
 * do, giving that page two headings and eight card-level <h1> elements.
 */
export const specialEvents: IndexEntry[] = [
  {
    title: 'Lifetime Achievement',
    summary:
      'In a momentous accolade, Rtn Thamizhachi Priya Govindaraj has been bestowed with the prestigious Best Trainer/Choreographer/Costume Designer Awards.',
    link: 'lifetime-achievement',
  },
  {
    title: 'FETTACK - Signature Event',
    summary:
      'Embark on a journey of empowerment with FETTACK, an exclusive Signature Project meticulously crafted and led by the visionary CEO & Founder of Samuthrika Academy, Rtn Thamizhachi Priya Govindaraj since 2015.',
    link: 'fettack',
  },
  {
    title: 'Journey as a Rotary Member',
    summary:
      'Embarking on the journey of Rotary excellence, Rtn Thamizhachi Priya Govindaraj stands as a beacon of inspiration within the Rotary community. Her tenure as a Rotarian is not merely a chapter but an illustrious saga that has touched remarkable heights.',
    link: 'rotary-journey',
  },
  {
    title: 'Event Management',
    summary:
      'Samuthrika Academy has etched an enduring legacy on the cultural canvas, orchestrating a plethora of events and cultivating partnerships that resonate with vitality and ingenuity.',
    link: 'event-management',
  },
];

const Index = () => {
  return (
    <Band tone="raised" pattern="lattice">
      <SectionLayout space="lg">
        <Reveal className="flex max-w-2xl flex-col gap-4">
          <Typography.Eyebrow>Beyond the classroom</Typography.Eyebrow>
          <Typography.Display1 className="text-4xl md:text-5xl lg:text-6xl">
            Special events
          </Typography.Display1>
          <Typography.Body className="text-muted-foreground">
            The work that happens outside the timetable — the signature project,
            the Rotary tenure, the awards, and the events the academy stages.
          </Typography.Body>
        </Reveal>

        <SectionIndex entries={specialEvents} />
      </SectionLayout>
    </Band>
  );
};

export default Index;
